<template>
    <section>
        <!--工具条-->
        <toolbar :buttonList="buttonList" @callFunction="callFunction"></toolbar>


        <!--列表-->
        <el-table :data="users" highlight-current-row @current-change="selectCurrentRow" v-loading="listLoading"
            @selection-change="selsChange" style="width: 100%;">
            <el-table-column type="selection" width="50" align="center">
            </el-table-column>
            <el-table-column type="index" width="80" align="center">
            </el-table-column>
            <el-table-column prop="uRealName" label="昵称" align="center">
            </el-table-column>
            <el-table-column prop="uLoginName" label="登录名" align="center">
            </el-table-column>
            <el-table-column prop="RoleNames" label="角色" align="center">
                <template slot-scope="scope">
                    <el-tag v-for="item in scope.row.RoleNames" :key="item.Id">{{ item }}</el-tag>
                </template>
            </el-table-column>
            <!--<el-table-column prop="name" label="姓名" >-->
            <!--</el-table-column>-->
            <el-table-column prop="sex" label="性别" width="100" :formatter="formatSex" align="center">
            </el-table-column>
            <el-table-column prop="birth" label="生日" :formatter="formatBirth" align="center">
            </el-table-column>
            <el-table-column prop="uStatus" label="状态" width="100" align="center">
                <template slot-scope="scope">
                    <el-tag :type="scope.row.uStatus == 0 ? 'success' : 'danger'" disable-transitions>
                        {{ scope.row.uStatus == 0 ? "正常" : "禁用" }}
                    </el-tag>
                </template>
            </el-table-column>
            <el-table-column label="操作" align="center">
                <template scope="scope">
                    <div class="flex">
                        <el-button size="small" type="primary" @click="handleSetTeacher(scope.row)">设置心理老师</el-button>
                        <el-button size="small" type="danger" @click="handleCancle(scope.row)">取消设置心理老师</el-button>
                    </div>
                </template>
            </el-table-column>
        </el-table>

        <!--工具条-->
        <el-col :span="24" class="toolbar">
            <el-button type="danger" @click="batchRemove" :disabled="this.sels.length === 0">批量删除</el-button>
            <el-pagination layout="prev, pager, next" @current-change="handleCurrentChange" :page-size="50"
                :total="total" style="float:right;">
            </el-pagination>
        </el-col>

        <!--编辑界面-->
        <el-dialog title="编辑" :visible.sync="editFormVisible" v-model="editFormVisible" :close-on-click-modal="false">
            <el-form :model="editForm" label-width="80px" :rules="editFormRules" ref="editForm">
                <el-form-item label="昵称" prop="uRealName">
                    <el-input v-model="editForm.uRealName" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="登录名" prop="uLoginName">
                    <el-input v-model="editForm.uLoginName" auto-complete="off"></el-input>
                </el-form-item>
                <!--<el-form-item label="密码" prop="uLoginPWD">-->
                <!--<el-input v-model="editForm.uLoginPWD" show-password  auto-complete="off"></el-input>-->
                <!--</el-form-item>-->

                <el-form-item label="角色" prop="RIDs">
                    <el-select multiple v-model="editForm.RIDs" placeholder="请选择角色">
                        <el-option :key="0" :label="'未选择角色'" :value="0"></el-option>
                        <el-option v-for="item in roles" :key="item.Id" :label="item.Name" :value="item.Id"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="性别">
                    <el-radio-group v-model="editForm.sex">
                        <el-radio class="radio" :label="1">男</el-radio>
                        <el-radio class="radio" :label="0">女</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="年龄">
                    <el-input-number v-model="editForm.age" :min="0" :max="200"></el-input-number>
                </el-form-item>
                <el-form-item label="生日">
                    <el-date-picker type="date" placeholder="选择日期" v-model="editForm.birth"></el-date-picker>
                </el-form-item>
                <el-form-item label="地址">
                    <el-input type="textarea" v-model="editForm.addr"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="editFormVisible = false">取消</el-button>
                <el-button type="primary" @click.native="editSubmit" :loading="editLoading">提交</el-button>
            </div>
        </el-dialog>

        <!--新增界面-->
        <el-dialog title="新增" :visible.sync="addFormVisible" v-model="addFormVisible" :close-on-click-modal="false">
            <el-form :model="addForm" label-width="80px" :rules="addFormRules" ref="addForm">
                <el-form-item label="昵称" prop="uRealName">
                    <el-input v-model="addForm.uRealName" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="登录名" prop="uLoginName">
                    <el-input v-model="addForm.uLoginName" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="密码" prop="uLoginPWD">
                    <el-input v-model="addForm.uLoginPWD" show-password auto-complete="off"></el-input>
                </el-form-item>
                <!--<el-form-item label="姓名" prop="name">-->
                <!--<el-input v-model="addForm.name" auto-complete="off"></el-input>-->
                <!--</el-form-item>-->
                <el-form-item label="性别">
                    <el-radio-group v-model="addForm.sex">
                        <el-radio class="radio" :label="1">男</el-radio>
                        <el-radio class="radio" :label="0">女</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="年龄">
                    <el-input-number v-model="addForm.age" :min="0" :max="200"></el-input-number>
                </el-form-item>
                <el-form-item label="生日">
                    <el-date-picker type="date" placeholder="选择日期" v-model="addForm.birth"></el-date-picker>
                </el-form-item>
                <el-form-item label="地址">
                    <el-input type="textarea" v-model="addForm.addr"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="addFormVisible = false">取消</el-button>
                <el-button type="primary" @click.native="addSubmit" :loading="addLoading">提交</el-button>
            </div>
        </el-dialog>

        <!-- 心理老师 -->
        <el-dialog title="设置心理老师" :visible.sync="dialogVisible" width="30%" label-position="top">
            <div>
                <el-form :model="TeacherForm" :rules="rules" ref="TeacherForm" class="demo-ruleForm">
                    <el-form-item label="上传图片" prop="Image">
                        <el-upload class="avatar-uploader" action="" :show-file-list="false"
                            :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload"
                            :http-request="uploadFile">
                            <img v-if="TeacherForm.Image" :src="TeacherForm.Image" class="avatar" />
                            <i v-else class="el-icon-plus avatar-uploader-icon flex-center"></i>
                        </el-upload>
                    </el-form-item>
                    <el-form-item label="手机号" prop="Phone">
                        <el-input type="number" v-model="TeacherForm.Phone"></el-input>
                    </el-form-item>
                    <el-form-item label="介绍" prop="Detail">
                        <el-input type="textarea" v-model="TeacherForm.Detail"></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="AddOnlineTeacher('TeacherForm')">确 定</el-button>
            </span>
        </el-dialog>
    </section>
</template>

<script>
import util from '../../../util/date'
import { testapi, getUserListPage, getRoleListPage, removeUser, batchRemoveUser, editUser, addUser, GetOnlineTeacherInfo, AddOnlineTeacher, UploadImg, DeleteOnlineTeacher } from '../../api/api';
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";

export default {
    components: { Toolbar },
    data() {
        var validatePass = (rule, value, callback) => {
            var regex = new RegExp('^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z\W_!@#$%^&*`~()-+=]+$)(?![a-z0-9]+$)(?![a-z\W_!@#$%^&*`~()-+=]+$)(?![0-9\W_!@#$%^&*`~()-+=]+$)[a-zA-Z0-9\W_!@#$%^&*`~()-+=]{8,16}$')
            const isTrue = regex.test(value);
            if (!isTrue) {
                callback(new Error('请输入密码长度8-16位，至少包含大小写字母，数字，特殊符号中的三种'));
            }
            callback()
        };
        return {
            filters: {
                name: ''
            },
            users: [],
            roles: [],
            total: 0,
            buttonList: [],
            currentRow: null,
            page: 1,
            listLoading: false,
            sels: [],//列表选中列

            addDialogFormVisible: false,
            editFormVisible: false,//编辑界面是否显示
            editLoading: false,
            editFormRules: {
                uLoginName: [
                    { required: true, message: '请输入登录名', trigger: 'blur' }
                ],
                uRealName: [
                    { required: true, message: '请输入昵称', trigger: 'blur' }
                ],
                birth: [
                    { required: true, message: '请填写生日', trigger: 'blur' }
                ]
            },
            //编辑界面数据
            editForm: {
                id: 0,
                uID: 0,
                RIDs: 0,
                uLoginName: '',
                uRealName: '',
                name: '',
                sex: -1,
                age: 0,
                birth: '',
                addr: ''
            },

            addFormVisible: false,//新增界面是否显示
            addLoading: false,
            addFormRules: {
                uLoginName: [
                    { required: true, message: '请输入登录名', trigger: 'blur' }
                ],
                uRealName: [
                    { required: true, message: '请输入昵称', trigger: 'blur' }
                ],
                uLoginPWD: [
                    { validator: validatePass, trigger: 'blur', required: true }
                ],
                birth: [
                    { required: true, message: '请填写生日', trigger: 'blur' }
                ]
            },
            //新增界面数据
            addForm: {
                name: '',
                uLoginName: '',
                uRealName: '',
                uLoginPWD: '',
                sex: -1,
                age: 0,
                birth: '',
                addr: ''
            },
            dialogVisible: false,
            TeacherForm: {
                SysUserId: 0,
                Image: '',
                Phone: '',
                Detail: ''
            },
            rules: {
                Image: [
                    { required: true, message: '请选择图片', trigger: 'change' },
                ],
                Phone: [
                    { required: true, message: '请输入手机号码', trigger: 'blur' },
                ],
                Detail: [
                    { required: true, message: '请输入介绍', trigger: 'blur' },
                ],
            }
        }
    },
    methods: {
        // 取消心理老师
        async handleCancle(item) {

            this.$confirm('是否取消该用户心理教师权限, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                let res = await DeleteOnlineTeacher({
                    id: item.uID
                })
                if (res.data.success) {
                    this.$message({
                        type: 'success',
                        message: '取消成功!'
                    });
                    this.getUsers();

                } else {
                    this.$message({
                        type: 'error',
                        message: res.data.msg
                    });
                }
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            });
        },
        // 设置心理老师确定
        async AddOnlineTeacher(formName) {
            this.$refs[formName].validate(async (valid) => {
                if (valid) {
                    let res = await AddOnlineTeacher({
                        sysUserId: this.TeacherForm.SysUserId,
                        image: this.TeacherForm.Image,
                        Phone: this.TeacherForm.Phone,
                        Detail: this.TeacherForm.Detail,
                    })
                    if (res.data.success) {
                        this.$message({
                            type: 'success',
                            message: '设置心理老师成功'
                        })
                        this.dialogVisible = false;
                        this.getUsers();
                        this.clearData()
                    } else {
                        this.$message({
                            type: 'error',
                            message: res.data.msg
                        })
                    }
                } else {

                    return false;
                }
            });

        },
        clearData() {
            this.TeacherForm = {
                SysUserId: 0,
                Image: '',
                Phone: '',
                Detail: ''
            };

            this.$nextTick(() => {
                this.$refs.TeacherForm.clearValidate()
            })
        },
        // 设置心理老师
        async handleSetTeacher(item) {

            let res = await GetOnlineTeacherInfo({
                Id: item.uID
            })
            if (res.data.success) {
                this.TeacherForm = res.data.response
                this.TeacherForm.SysUserId = item.uID
                console.log(this.TeacherForm, 'this.TeacherForm')
                this.dialogVisible = true

            } else {
                this.clearData()
                this.TeacherForm.SysUserId = item.uID
                this.dialogVisible = true
            }
        },
        // 上传文件
        uploadFile(item) {
            const fileObj = item.file;
            // FormData 对象
            const form = new FormData();
            // 文件对象
            form.append("file", fileObj);
            form.append("comId", this.comId);
            UploadImg(form).then((response) => {
                if (response.data.success) {
                    this.TeacherForm.Image = response.data.response;
                    this.$message.info("文件：" + fileObj.name + "上传成功");
                } else {
                    this.$message.info("文件：" + fileObj.name + "上传失败");
                }
            });
        },
        handleAvatarSuccess(res, file) {
            this.TeacherForm.Image = URL.createObjectURL(file.raw);
        },
        beforeAvatarUpload(file) {
            if (
                !(
                    file.type === "image/png" ||
                    file.type === "image/gif" ||
                    file.type === "image/jpg" ||
                    file.type === "image/jpeg"
                )
            ) {
                this.$notify.warning({
                    title: "警告",
                    message:
                        "请上传格式为image/png, image/gif, image/jpg, image/jpeg的图片",
                });
            }
            let size = file.size / 1024 / 1024 / 2;
            if (size > 2) {
                this.$notify.warning({
                    title: "警告",
                    message: "图片大小必须小于2M",
                });
            }
        },
        selectCurrentRow(val) {
            this.currentRow = val;
        },
        callFunction(item) {
            this.filters = {
                name: item.search
            };
            this[item.Func].apply(this, item);
        },
        //性别显示转换
        formatSex: function (row, column) {
            return row.sex == 1 ? '男' : row.sex == 0 ? '女' : '未知';
        },
        formatBirth: function (row, column) {
            return (!row.birth || row.birth == '') ? '' : util.formatDate.format(new Date(row.birth), 'yyyy-MM-dd');
        },
        handleCurrentChange(val) {
            this.page = val;
            this.getUsers();
        },
        //获取用户列表
        getUsers() {
            let para = {
                page: this.page,
                key: this.filters.name
            };
            this.listLoading = true;

            testapi();
            //NProgress.start();
            getUserListPage(para).then((res) => {

                this.total = res.data.response.dataCount;
                this.users = res.data.response.data;
                this.listLoading = false;
                //NProgress.done();
            });
        },
        //删除
        handleDel() {
            let row = this.currentRow;
            if (!row) {
                this.$message({
                    message: "请选择要删除的一行数据！",
                    type: "error"
                });

                return;
            }
            this.$confirm('确认删除该记录吗?', '提示', {
                type: 'warning'
            }).then(() => {
                this.listLoading = true;
                //NProgress.start();
                let para = { id: row.uID };
                removeUser(para).then((res) => {

                    if (util.isEmt.format(res)) {
                        this.listLoading = false;
                        return;
                    }
                    this.listLoading = false;
                    //NProgress.done();
                    if (res.data.success) {
                        this.$message({
                            message: '删除成功',
                            type: 'success'
                        });

                    } else {
                        this.$message({
                            message: res.data.msg,
                            type: 'error'
                        });
                    }

                    this.getUsers();
                });
            }).catch(() => {

            });
        },
        //显示编辑界面
        handleEdit() {
            let row = this.currentRow;
            if (!row) {
                this.$message({
                    message: "请选择要编辑的一行数据！",
                    type: "error"
                });

                return;
            }
            this.editFormVisible = true;
            this.editForm = Object.assign({}, row);

            getRoleListPage().then((res) => {
                this.roles = res.data.response.data;
            });

        },
        //显示新增界面
        handleAdd() {
            this.addFormVisible = true;
            this.addForm = {
                uLoginName: '',
                uRealName: '',
                uLoginPWD: '',
                name: '',
                sex: -1,
                age: 0,
                birth: '',
                addr: ''
            };
        },
        //编辑
        editSubmit: function () {
            this.$refs.editForm.validate((valid) => {
                if (valid) {
                    this.$confirm('确认提交吗？', '提示', {}).then(() => {
                        this.editLoading = true;
                        //NProgress.start();
                        let para = Object.assign({}, this.editForm);

                        para.birth = (!para.birth || para.birth == '') ? util.formatDate.format(new Date(), 'yyyy-MM-dd') : util.formatDate.format(new Date(para.birth), 'yyyy-MM-dd');

                        editUser(para).then((res) => {

                            if (util.isEmt.format(res)) {
                                this.editLoading = false;
                                return;
                            }
                            if (res.data.success) {
                                this.editLoading = false;
                                //NProgress.done();
                                this.$message({
                                    message: res.data.msg,
                                    type: 'success'
                                });
                                this.$refs['editForm'].resetFields();
                                this.editFormVisible = false;
                                this.getUsers();
                            } else {
                                this.$message({
                                    message: res.data.msg,
                                    type: 'error'
                                });

                            }
                        });
                    });
                }
            });
        },
        //新增
        addSubmit: function () {
            this.$refs.addForm.validate((valid) => {
                if (valid) {
                    this.$confirm('确认提交吗？', '提示', {}).then(() => {
                        this.addLoading = true;
                        //NProgress.start();
                        let para = Object.assign({}, this.addForm);
                        para.birth = (!para.birth || para.birth == '') ? util.formatDate.format(new Date(), 'yyyy-MM-dd') : util.formatDate.format(new Date(para.birth), 'yyyy-MM-dd');
                        addUser(para).then((res) => {

                            if (util.isEmt.format(res)) {
                                this.addLoading = false;
                                return;
                            }

                            if (res.data.success) {
                                this.addLoading = false;
                                //NProgress.done();
                                this.$message({
                                    message: res.data.msg,
                                    type: 'success'
                                });
                                this.$refs['addForm'].resetFields();
                                this.addFormVisible = false;
                                this.getUsers();
                            }
                            else {
                                this.$message({
                                    message: res.data.msg,
                                    type: 'error'
                                });

                            }

                        });

                    });
                }
            });
        },
        selsChange: function (sels) {
            this.sels = sels;
        },
        //批量删除
        batchRemove: function () {

            // return;

            var ids = this.sels.map(item => item.uID).toString();
            this.$confirm('确认删除选中记录吗？', '提示', {
                type: 'warning'
            }).then(() => {
                this.listLoading = true;
                //NProgress.start();
                let para = { ids: ids };

                batchRemoveUser(para).then((res) => {
                    this.listLoading = false;
                    //NProgress.done();
                    this.$message({
                        message: '该功能未开放',
                        type: 'warning'
                    });
                    console.log(res)
                });
            }).catch(() => {

            });
        }
    },
    mounted() {
        this.getUsers();

        let routers = window.localStorage.router
            ? JSON.parse(window.localStorage.router)
            : [];
        this.buttonList = getButtonList(this.$route.path, routers);
    }
}

</script>

<style scoped>
.flex-center {
    display: flex;
    align-items: center;
    justify-content: center;
}

.flex {
    display: flex;

}
</style>
